import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import {
  PatchDocFiltersDictionnaryAction,
  PatchIsBatAction,
  PatchShowPopupWarningAction
} from '../../states/property-bag/property-bag-state.actions';
import { DocFiltersDictionnary } from '../../states/property-bag/property-bag-state.model';
import { PropertyBagState } from '../../states/property-bag/property-bag.state';

@Injectable({
  providedIn: 'root'
})
export class PropertyBagService {
  isBat$: Observable<boolean>;
  showPopupWarning$: Observable<boolean>;
  docFiltersDictionnary$: Observable<DocFiltersDictionnary>;

  constructor(private store: Store) {
    this.isBat$ = this.store.select(PropertyBagState.isBat);

    this.showPopupWarning$ = this.store.select(
      PropertyBagState.showPopupWarning
    );

    this.docFiltersDictionnary$ = this.store.select(
      PropertyBagState.docFiltersDictionnary
    );
  }

  patchIsBat(isBat: boolean): Observable<any> {
    return this.store.dispatch(new PatchIsBatAction(isBat));
  }

  patchShowPopupWarning(showPopupWarning: boolean): Observable<any> {
    return this.store.dispatch(
      new PatchShowPopupWarningAction(showPopupWarning)
    );
  }

  patchDocFiltersDictionnary(
    docFiltersDictionnary: DocFiltersDictionnary
  ): Observable<any> {
    return this.store.dispatch(
      new PatchDocFiltersDictionnaryAction(docFiltersDictionnary)
    );
  }
}
